export const ProjectsTableColumns = (isArabic) => [
    { id: 'title',        label: isArabic ? 'العنوان'             : 'Title',        align: 'start'  },
    { id: 'slug',         label: isArabic ? 'الرابط (Slug)'       : 'Slug',         align: 'start'  },
    { id: 'client',       label: isArabic ? 'العميل'              : 'Client',       align: 'start'  },
    { id: 'show_in_home', label: isArabic ? 'عرض في الرئيسية'     : 'Show in Home', align: 'center' },
    { id: 'sort_order',   label: isArabic ? 'ترتيب'               : 'Sort Order',   align: 'center' },
    { id: 'created_at',   label: isArabic ? 'تاريخ الإضافة'       : 'Created At',   align: 'start'  },
];
